import { render, staticRenderFns } from "./ConfirmVerificationDialog.vue?vue&type=template&id=70fefae3"
import script from "./ConfirmVerificationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmVerificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports